// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vote-badge {
  text-align: center;
  position: relative;
  display: inline-block;
  width: 100%;
  font-size: var(--fontSize-7, 24px);
  font-weight: var(--fontWeight-bold, 700);
  line-height: 24px;
  color: var(--ds-text-subtle);
  align-self: center;
}

.vote-badge-revealed {
  text-align: center;
  position: relative;
  display: inline-block;
  width: 100%;
  font-size: var(--fontSize-7, 24px);
  font-weight: var(--fontWeight-bold, 700);
  line-height: 24px;
  color: var(--ds-text-subtle);
  align-self: center;
}

.vote {
  visibility: hidden;
  opacity: 0;
  font-size: var(--fontSize-2, 12px);
  font-weight: var(--fontWeight-bold, 700);
  line-height: 16px;
  text-align: center;
  width: 100%;
  border-radius: 2px;
  background-color: var(--background-accent-blue-subtle, #579dff);
  overflow: hidden;
  color: var(--ds-text-inverse, #ffffff);
  align-self: flex-end;
}

.vote.voted {
  visibility: visible;
  opacity: 1;
}

.card {
  margin-bottom: 8px;
  margin-right: 4px;
}

.edit-vote {
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
}
.card-header {
  display: flex;
  align-items: baseline;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  min-height: 20px;
}

.card-header:only-child {
  justify-content: flex-end;
}

.voting-card {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 1px;
  padding: 0;
  padding-bottom: 0;
  box-sizing: border-box;
  transform-origin: bottom;
  height: 100%;
  width: 100%;
  line-height: 33px;
  gap: 4px;
}

.edit-icon-container {
  width: 20px;
  height: 20px;
  padding: 2px;
  display: flex;
}

.edit-icon {
  cursor: pointer;
  pointer-events: all;
  border-radius: 3px;
  
}
.edit-icon:hover {
  background-color: var(--ds-background-neutral-subtle-hovered);
}

.card.card-summary:first-child {
  margin-left: 0;
}

.card.card-summary {
  position: relative;
  margin-left: -16px;
  margin-right: 0;
}

.card-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.card-wrapper .card-non-interactive {
  cursor: default;
  margin-bottom: 8px;
  margin-right: 4px;
  pointer-events: none;
}

.card-wrapper .card .card-inner {
  background-color: var(--ds-background-input);
  display: flex;
  position: relative;
  left: 0px;
  -webkit-transition: "400ms cubic-bezier(0.4, 0, 0.2, 1)";
  transition: "400ms cubic-bezier(0.4, 0, 0.2, 1)";
  pointer-events: none;
}

.card-wrapper .card:hover .card-inner,
.card-wrapper .card.selected .card-inner {
  transform: translateY(-6px);
  transition: "400ms cubic-bezier(0.4, 0, 0.2, 1)";
  box-shadow: "400ms cubic-bezier(0.4, 0, 0.2, 1)";
}

.card-wrapper .card.selected .card-inner {
  transform: translateY(-10px);
}

.card-wrapper .card:hover ~ .card .card-inner,
.card-wrapper .card.selected ~ .card .card-inner {
  position: relative;
}

.card-wrapper .card:hover .vote {
  visibility: visible;
  opacity: 1;
}

.card-wrapper .card:hover .stroke,
.card-wrapper .card.selected .stroke {
  stroke-dashoffset: 100;
  transition: 0.6s ease-out;
}

.card-wrapper .shadow-underneath {
  opacity: 0;
  display: flex;
  justify-content: center;
}

.card-wrapper .card:hover .shadow-underneath {
  transition: opacity 0.4s ease-in-out;
  opacity: 1;
}

.card-wrapper .selected .shadow-underneath {
  opacity: 1;
}

.card-wrapper .selected .card-header {
  justify-content: flex-end;
}


.card-inner {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  justify-content: center;
  align-items: baseline;
  box-shadow: "0px 6px 8px rgba(0, 0, 0, 0.2)";
  border: 1px solid #85b8ff;
  border-radius: 3px;
  position: relative;
  width: 52px;
  height: 76px;

  background-color: var(--ds-background-input);
  display: flex;
  left: 0px;
  pointer-events: all;

  -webkit-transition: 200ms ease-in-out;
  transition: 200ms ease-in-out;
}

.pointer {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/game/Cards/cards.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,kCAAkC;EAClC,wCAAwC;EACxC,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,kCAAkC;EAClC,wCAAwC;EACxC,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,+DAA+D;EAC/D,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;;AAEpB;AACA;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,wDAAwD;EACxD,gDAAgD;EAChD,oBAAoB;AACtB;;AAEA;;EAEE,2BAA2B;EAC3B,gDAAgD;EAChD,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,4CAA4C;EAC5C,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,4CAA4C;EAC5C,aAAa;EACb,SAAS;EACT,mBAAmB;;EAEnB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".vote-badge {\n  text-align: center;\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  font-size: var(--fontSize-7, 24px);\n  font-weight: var(--fontWeight-bold, 700);\n  line-height: 24px;\n  color: var(--ds-text-subtle);\n  align-self: center;\n}\n\n.vote-badge-revealed {\n  text-align: center;\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  font-size: var(--fontSize-7, 24px);\n  font-weight: var(--fontWeight-bold, 700);\n  line-height: 24px;\n  color: var(--ds-text-subtle);\n  align-self: center;\n}\n\n.vote {\n  visibility: hidden;\n  opacity: 0;\n  font-size: var(--fontSize-2, 12px);\n  font-weight: var(--fontWeight-bold, 700);\n  line-height: 16px;\n  text-align: center;\n  width: 100%;\n  border-radius: 2px;\n  background-color: var(--background-accent-blue-subtle, #579dff);\n  overflow: hidden;\n  color: var(--ds-text-inverse, #ffffff);\n  align-self: flex-end;\n}\n\n.vote.voted {\n  visibility: visible;\n  opacity: 1;\n}\n\n.card {\n  margin-bottom: 8px;\n  margin-right: 4px;\n}\n\n.edit-vote {\n  display: flex;\n  align-items: flex-end;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n}\n.card-header {\n  display: flex;\n  align-items: baseline;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 20px;\n}\n\n.card-header:only-child {\n  justify-content: flex-end;\n}\n\n.voting-card {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0 1px;\n  padding: 0;\n  padding-bottom: 0;\n  box-sizing: border-box;\n  transform-origin: bottom;\n  height: 100%;\n  width: 100%;\n  line-height: 33px;\n  gap: 4px;\n}\n\n.edit-icon-container {\n  width: 20px;\n  height: 20px;\n  padding: 2px;\n  display: flex;\n}\n\n.edit-icon {\n  cursor: pointer;\n  pointer-events: all;\n  border-radius: 3px;\n  \n}\n.edit-icon:hover {\n  background-color: var(--ds-background-neutral-subtle-hovered);\n}\n\n.card.card-summary:first-child {\n  margin-left: 0;\n}\n\n.card.card-summary {\n  position: relative;\n  margin-left: -16px;\n  margin-right: 0;\n}\n\n.card-wrapper {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.card-wrapper .card-non-interactive {\n  cursor: default;\n  margin-bottom: 8px;\n  margin-right: 4px;\n  pointer-events: none;\n}\n\n.card-wrapper .card .card-inner {\n  background-color: var(--ds-background-input);\n  display: flex;\n  position: relative;\n  left: 0px;\n  -webkit-transition: \"400ms cubic-bezier(0.4, 0, 0.2, 1)\";\n  transition: \"400ms cubic-bezier(0.4, 0, 0.2, 1)\";\n  pointer-events: none;\n}\n\n.card-wrapper .card:hover .card-inner,\n.card-wrapper .card.selected .card-inner {\n  transform: translateY(-6px);\n  transition: \"400ms cubic-bezier(0.4, 0, 0.2, 1)\";\n  box-shadow: \"400ms cubic-bezier(0.4, 0, 0.2, 1)\";\n}\n\n.card-wrapper .card.selected .card-inner {\n  transform: translateY(-10px);\n}\n\n.card-wrapper .card:hover ~ .card .card-inner,\n.card-wrapper .card.selected ~ .card .card-inner {\n  position: relative;\n}\n\n.card-wrapper .card:hover .vote {\n  visibility: visible;\n  opacity: 1;\n}\n\n.card-wrapper .card:hover .stroke,\n.card-wrapper .card.selected .stroke {\n  stroke-dashoffset: 100;\n  transition: 0.6s ease-out;\n}\n\n.card-wrapper .shadow-underneath {\n  opacity: 0;\n  display: flex;\n  justify-content: center;\n}\n\n.card-wrapper .card:hover .shadow-underneath {\n  transition: opacity 0.4s ease-in-out;\n  opacity: 1;\n}\n\n.card-wrapper .selected .shadow-underneath {\n  opacity: 1;\n}\n\n.card-wrapper .selected .card-header {\n  justify-content: flex-end;\n}\n\n\n.card-inner {\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  justify-content: center;\n  align-items: baseline;\n  box-shadow: \"0px 6px 8px rgba(0, 0, 0, 0.2)\";\n  border: 1px solid #85b8ff;\n  border-radius: 3px;\n  position: relative;\n  width: 52px;\n  height: 76px;\n\n  background-color: var(--ds-background-input);\n  display: flex;\n  left: 0px;\n  pointer-events: all;\n\n  -webkit-transition: 200ms ease-in-out;\n  transition: 200ms ease-in-out;\n}\n\n.pointer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
